import { render, staticRenderFns } from "./HeaderDropdownProfile.vue?vue&type=template&id=05789d9d"
import script from "./HeaderDropdownProfile.vue?vue&type=script&lang=ts"
export * from "./HeaderDropdownProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports